// src/components/commom/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation(); // 현재 URL 경로 감지

  useEffect(() => {
    // 경로가 바뀔 때마다 맨 위로 이동
    window.scrollTo(0, 0);
  }, [pathname]); // pathname이 바뀔 때만 실행됨

  return null;
};

export default ScrollToTop;
